import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerLoader',
  props: {
    size: {
        type: String,
        default: "48px"
    },
    color: {
        type: String,
        default: "#6366f1" // purple
    },
    borderWidth: {
        type: String,
        default: "4px"
    }
},
  setup(__props) {

const props = __props;



function hexToRgb(hex: string): string {
    // Basic hex to rgb conversion for the alpha background borders
    let c = hex.substring(1).split("");
    if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    const num = parseInt(c.join(""), 16);
    return [(num >> 16) & 255, (num >> 8) & 255, num & 255].join(",");
}

const loaderStyles = computed<Record<string, string>>(() => {
    return {
        width: props.size,
        height: props.size,
        borderWidth: props.borderWidth,
        borderTopColor: props.color,
        borderRightColor: `rgba(${hexToRgb(props.color)}, 0.2)`,
        borderBottomColor: `rgba(${hexToRgb(props.color)}, 0.2)`,
        borderLeftColor: `rgba(${hexToRgb(props.color)}, 0.2)`
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "spinner-loader",
    style: _normalizeStyle(loaderStyles.value)
  }, null, 4))
}
}

})